// @flow

import React, {type Node} from 'react';
import styled from 'styled-components';

import colors from './colors';

const StyledConnectorDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;

  > .toolbar-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;

    > .content {
      max-width: calc(100vw - 10px);
      background: '${colors.tooltipBackground}';
      border-bottom: 4px solid ${colors.border};
      border-radius: 2px;
      padding: 2px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
        0 1px 1px 1px rgba(0, 0, 0, 0.16), 0 -1px 3px rgba(0, 0, 0, 0.12),
        0 -1px 1px 1px rgba(0, 0, 0, 0.16);
    }

    > .arrow {
      top: -1px;
      width: 0;
      height: 0;
      border-style: solid;
      margin: 5px;
      border-width: 5px 5px 0 5px;
      border-color: ${colors.border} transparent transparent transparent;
      bottom: -5px;
      margin-top: 0;
      margin-bottom: 0;
    }
  }
`;

type Props = {
  canvas: Node,
  toolbar: Node,
  className: string,
};

export const BieConnector = ({canvas, toolbar, className}: Props) => (
  <StyledConnectorDiv className={`connector ${className}`}>
    <div className="toolbar-container">
      {toolbar}
      <div className="arrow" />
    </div>
    {canvas}
  </StyledConnectorDiv>
);

BieConnector.defaultProps = {className: ''};
